
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import logos from '../../assets/images/logos.png';

export default function Footer() {
  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Admissions', href: '/admissions' },
    { name: 'Academics', href: '/academics' },
    { name: 'Student Life', href: '/student-life' },
    { name: 'Contact', href: '/contact' },
  ];

  const academics = [
    { name: 'Early Years', href: '/academics/early-years' },
    { name: 'Primary Education', href: '/academics/primary' },
    { name: 'Secondary Education', href: '/academics/secondary' },
    { name: 'Entrance Exams', href: '/admissions/exams' },
  ];

 const socialLinks = [
  { name: 'Facebook', icon: 'ri-facebook-fill', href: 'https://www.facebook.com/profile.php?id=61574987140631' },
  { name: 'Twitter', icon: 'ri-twitter-x-fill', href: 'https://x.com/myrehobothsch?t=zkaV-GTj0AQyx5atJpRNkA&s=09' },
  { name: 'Instagram', icon: 'ri-instagram-fill', href: 'https://instagram.com/myrehoboth_schools' },
  { name: 'Whatsapp', icon: 'ri-whatsapp-fill', href: 'https://whatsapp.com/channel/0029VbBVHJX0gcfNA8u8mC1T' }, // Replace with actual channel ID
  { name: 'TikTok', icon: 'ri-tiktok-fill', href: 'https://vm.tiktok.com/ZSH7vgSh9BTDj-B3bj0/' },
  { name: 'Youtube', icon: 'ri-youtube-fill', href: 'https://www.youtube.com/@myrehobothschoolsakure' }, // Replace with actual channel ID
];
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* College Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg"><img src= {logo} alt="" /></span>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                My Rehoboth Schools
              </h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Excellence in Education. Nurturing minds, building futures, and creating leaders of tomorrow through innovative learning and holistic development.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-800 transition-colors duration-200"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Academics */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Academics</h4>
            <ul className="space-y-3">
              {academics.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-green-400 mt-1"></i>
                <div>
                  <p className="text-gray-300">My Rehoboth Schools school</p>
                  <p className="text-gray-300">Orita Obele Estate, Akure, Ondo State</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400"></i>
                <p className="text-gray-300">+234 (0) 806-635-8320</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400"></i>
                <p className="text-gray-300">+234 (0) 803-749-2710</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400"></i>
                <p className="text-gray-300">+234 (0) 815-653-2220</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-green-400"></i>
                <p className="text-gray-300">info@myrehobothschools.edu.ng</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-green-400"></i>
                <div>
                  <p className="text-gray-300">Mon - Fri: 7:30 AM - 4:00 PM</p>
                  <p className="text-gray-300">Sat: 8:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 My Rehoboth Schools. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              Terms of Service
            </Link>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
